// extracted by mini-css-extract-plugin
export var button = "_j8-2";
export var card = "_j8-0";
export var closeButtonContainer = "_j8-3";
export var iconContainer = "_j8-1";